import React, { useMemo } from 'react'

import { A4_PORTRAIT } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'
import { Title } from 'src/components/Ant'
import { useSelector } from 'react-redux'

import { Footer, OptionsBar, TitleReport } from '..'
import { SectionHeader, TableDetail } from './components'
import { WrapPage, WrapPageContent } from '../../styles'
import * as CSS from './styles'

enum mesures {
  MAX_REGISTER_PER_PAGE = 41,
  MINIMUM_TABLE = 95,
  PAGE_HEIGHT = 1030,
  SECTION_HEADER = 95,
  SECTION_TITLE = 66,
  SINGLE_REGISTER = 21,
  SPACER = 20,
  TABLE_HEADER = 38,
  USER_NAME = 36
}

function R2() {
  const {
    reports: {
      reportsResources: {
        R2Data: { data },
        R2Header: { data: Hdata }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (!data.length && !Hdata.length) {
      return []
    }

    const tempPages: JSX.Element[][] = []

    let index = 0
    let isFirstPage = true
    let activeUserName = ''
    // Make pages //
    do {
      const page: JSX.Element[] = []
      let availableSpace = mesures.PAGE_HEIGHT

      availableSpace -= mesures.SECTION_TITLE
      page.push(<TitleReport title="web.report.1.title" />)

      if (isFirstPage) {
        isFirstPage = false
        availableSpace -= mesures.SECTION_HEADER
        page.push(<SectionHeader />)
      }

      while (index < data.length && availableSpace > mesures.MINIMUM_TABLE) {
        activeUserName = data[index].full_name

        const maxRecordsPossible = data.slice(
          index,
          index + mesures.MAX_REGISTER_PER_PAGE
        )
        const amountUserRegisters = maxRecordsPossible.filter(
          // eslint-disable-next-line no-loop-func
          services => `${services.user_id}` === `${data[index].user_id}`
        ).length

        if (amountUserRegisters > 0) {
          let spaceForRegisters = Math.trunc(
            (availableSpace - mesures.TABLE_HEADER - mesures.USER_NAME) /
              mesures.SINGLE_REGISTER
          )

          const range =
            amountUserRegisters < spaceForRegisters
              ? amountUserRegisters
              : spaceForRegisters
          availableSpace -= mesures.USER_NAME
          page.push(<Title level={4}>{activeUserName}</Title>)

          const rangeToPrint = data.slice(index, index + range)
          availableSpace -=
            mesures.TABLE_HEADER + mesures.SINGLE_REGISTER * range
          page.push(
            <CSS.TableDiv>
              <TableDetail dataSource={rangeToPrint} />
            </CSS.TableDiv>
          )

          if (availableSpace >= mesures.SPACER) {
            availableSpace -= mesures.SPACER
            page.push(<CSS.Spacer />)
          }

          index += range
        }
      }
      tempPages.push(page)
    } while (index < data.length)
    return tempPages
  }, [Hdata.length, data])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </WrapPage>
      ))}
    </>
  )
}

export default R2
